<script>
import { getDepartments } from '@/api/dealer'
import TaskTemplateDragHandle from '@/components/tasks/form/TaskTemplateDragHandle.vue'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'

export default {
  components: {
    'mia-feature-input': FeatureInput,
    'mia-feature-select': FeatureSelect,
    'mia-task-template-drag-handle': TaskTemplateDragHandle
  },

  model: {
    prop: 'group',
    event: 'update:group'
  },

  props: {
    group: {
      type: Object,
      required: true
    },

    draggable: {
      type: Boolean,
      default: false
    },

    dragHandleClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      internalDepartments: []
    }
  },

  computed: {
  },

  created() {
    this.loadInternalDepartments()
  },

  methods: {
    async loadInternalDepartments() {
      const [error, response] = await getDepartments()

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Interne Abteilungen konnten nicht geladen werden']
        })
        return
      }

      this.internalDepartments = response
    },

    updateTitle(newTitle) {
      this.$emit('update:group', {
        ...this.group,
        item_title: newTitle
      })
    },

    onTitleInput(value) {
      this.updateTitle(value)
    },

    onDepartmentInput(value) {
      this.$emit('update:group', {
        ...this.group,
        item_department_id: value || null
      })
    },

    deleteGroup() {
      console.log('xxxx')
      this.$emit('delete-group')
    }
  }
}
</script>

<template>
  <div class="bg-gray-100 p-2 border border-gray-200 rounded-sm">
    <div
      :class="{
        flex: draggable
      }"
    >
      <div v-if="draggable">
        <mia-task-template-drag-handle :class="dragHandleClass" />
      </div>
      <div
        class="flex items-center justify-between"
        :class="{ 'flex-1 ml-3': draggable }"
      >
        <div class="flex-1 relative">
          <mia-feature-input
            label="Name der Gruppe"
            :value="group.item_title"
            @input="onTitleInput"
          />
        </div>

        <div class="flex ml-3">
          <mia-feature-select
            class="ml-3"
            label="Interne Abteilung"
            @input="onDepartmentInput"
          >
            <template #options>
              <option
                value=""
                disabled
              >
                Abteilung wählen
              </option>
              <option
                v-for="department in internalDepartments"
                :key="department.id"
                :value="department.id"
                :selected="department.id === group.item_department_id"
              >
                {{ department.item_name }}
              </option>
            </template>
          </mia-feature-select>
        </div>
      </div>
    </div>

    <slot />


    <div class="mt-6 flex justify-end">
      <button
        type="button"
        class="bg-red-100 text-red-500 border border-red-200 rounded-sm px-3 py-1 text-sm hover:border-red-600 hover:bg-red-500 hover:text-white focus:outline-none"
        @click="deleteGroup"
      >
        Gruppe löschen
      </button>
    </div>
  </div>
</template>
